export default __webpack_public_path__ + "static/media/appointments.4ede4a5a.png";